import React,{useContext} from "react";
import themeContext from "../../context/theme/ThemeContext";

const Download = () => {
  const {themeName} = useContext(themeContext);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="14"
      viewBox="0 0 15 14"
      fill="none"
    >
      <path
        d="M14.5 7C14.5 10.866 11.366 14 7.5 14C3.63401 14 0.5 10.866 0.5 7C0.5 3.13401 3.63401 0 7.5 0C11.366 0 14.5 3.13401 14.5 7ZM7.69139 10.4621C7.74949 10.438 7.80398 10.4026 7.85143 10.3557L7.85375 10.3534L10.3536 7.85355C10.5488 7.65829 10.5488 7.34171 10.3536 7.14645C10.1583 6.95118 9.84171 6.95118 9.64645 7.14645L8 8.79289V4C8 3.72386 7.77614 3.5 7.5 3.5C7.22386 3.5 7 3.72386 7 4V8.79289L5.35355 7.14645C5.15829 6.95118 4.84171 6.95118 4.64645 7.14645C4.45118 7.34171 4.45118 7.65829 4.64645 7.85355L7.14625 10.3534L7.14857 10.3557C7.23888 10.4449 7.36301 10.5 7.5 10.5C7.56779 10.5 7.63244 10.4865 7.69139 10.4621Z"
        fill={`${themeName==='light'?"#FFFFFF":"#707070"}`}
      />
    </svg>
  );
};

export default Download;
